import slick from '@/plugins/slick';
import rellax from '@/plugins/rellax';

export default {
    init() {
        slick.init();
        rellax.init();
    },
};
